module.exports = __webpack_public_path__ + "card.png?bede7e369052122f387c68557cf4d192";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card.png
// module id = 271
// module chunks = 0